import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Snackbar } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Card, Dropdown, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Dots from "@assets/images/Menu - Mini.svg";
import Delete from "@assets/images/delete2.png";
import Edit from "@assets/images/editIcon.svg";
import WheelComponent from "../WheelComponent";
import Clone from "@assets/images/clone-wheel.svg";
import "./style.css";
import { ASSETS } from "../../utils/config";
import Private from "@assets/images/private.svg";
import Share from "@assets/images/share2.svg";
import Duplicate from "@assets/images/duplicate.svg";
import { colors } from "../../utils";
import { useDuplicateWheel } from "../../services/mutations";
import { toPng } from "html-to-image";

export default function MainWheel({
  mainName,
  data,
  onDeleteWheelPress = () => {},
  deletingWheelId,
  isEditable = true,
  handleCloneWheel,
  wheelType,
  onMakePrivatePress = () => {},
  toggleDropdown,
  isDropDownOpen,
}) {
  const nav = useNavigate();

  const [open, setOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [snackbarType, setSnackbarType] = useState("info");

  const handleShare = () => {
    const wheelID = data?.id;
    var _shareURL = window.location.origin + "/wheel/" + wheelID;

    navigator.clipboard.writeText(_shareURL);
    // setOpen(true);
    setSnackbarType("success");
    setSnackbarMessage("Link Copied!");
    setSnackbarOpen(true);
  };

  const [chartState, setChartState] = useState([]);
  useEffect(() => {
    const wheelData = data && data?.wheel_section[0]?.activity_wheel;

    const wheelUpdatedData = wheelData?.map((obj, index) => ({
      label: "blank",
      value: "1",
      isBlank: false,
      // position: 0,
      ...obj,
    }));

    const wheelUpdatedDataSorted = wheelUpdatedData?.sort(
      (a, b) => a.position - b.position
    );

    setChartState(wheelUpdatedDataSorted);
  }, [data]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const onEditData = () => {
    // nav(`/EditCustomWheel/${data?.id}/null`);
  };

  const onDeletePress = () => {
    onDeleteWheelPress("main", data?.id);
  };

  const onPrivatePress = () => {
    onMakePrivatePress(data?.id, data, wheelType);
  };

  const { mutate, isLoading, isError, data:duplicatewheeldata } = useDuplicateWheel();

  const onDuplicateWheel = () => {
    mutate(data?.id);
  };

  const onCardPress = (e) => {
    if (data?.id) {
      nav(`/wheel/${data?.id}`);
    } else {
      console.error("Data ID not available");
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  const getSnackbarStyle = () => {
    switch (snackbarType) {
      case "downloading":
        return { backgroundColor: colors.primaryLight }; // Amber for downloading
      case "success":
        return { backgroundColor: colors.primary }; // Green for success
      case "error":
        return { backgroundColor: "#F44336" }; // Red for error
      default:
        return {};
    }
  };

  const ref = useRef(null);
  const onDownloadButtonClick = useCallback(() => {
    if (ref.current === null) {
      return;
    }
    setIsDownloading(true);
    setSnackbarMessage("Downloading image...");
    setSnackbarType("downloading");
    setSnackbarOpen(true);

    toPng(ref.current, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = `${mainName}-${data?.id}.png`;
        link.href = dataUrl;
        link.click();
        setIsDownloading(false);
        setSnackbarMessage("Image successfully downloaded!");
        setSnackbarType("success");
        setSnackbarOpen(true);
      })
      .catch((err) => {
        setIsDownloading(false);
        setSnackbarMessage("Error downloading image.");
        setSnackbarType("error");
        setSnackbarOpen(true);
        console.error(err);
      });
  }, [ref, mainName, data?.id]);

  const showIsDeletingLoader = deletingWheelId === data?.id;

  if(data)
  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        message={`Link copied to clipboard!`}
        action={
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      />

      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        ContentProps={{
          style: getSnackbarStyle(),
        }}
        action={
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleSnackbarClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      />

      <div style={{ position: "relative" }}>
        {showIsDeletingLoader && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "30px",
              zIndex: 999,
            }}
          >
            <Spinner
              style={{ color: "white" }}
              animation="border"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        )}
        <Card
          onClick={onCardPress}
          style={{
            borderRadius: "30px",
            marginBottom: "3px",
            marginTop: "40px",

            cursor: "pointer",
          }}
        >
          <Card.Body>
            <div className="row" style={{ height: "50px", padding: "10px" }}>
              <div className="col-lg-8">
                <Card.Title
                  style={{
                    fontSize: "20px",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontFamily: "DM Sans",
                    color: "#565556",
                    fontWeight: "700",
                    marginTop: "10px",
                  }}
                >
                  {mainName}
                </Card.Title>
              </div>
              <div className="col-lg-4">
                <div className="row">
                  <div className="col-lg-12" style={{ textAlign: "end" }}>
                    <Dropdown
                      style={{ padding: 0, margin: 0, zIndex: 10 }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Dropdown.Toggle
                        variant="none"
                        style={{ border: 0, margin: 0, padding: 0 }}
                      >
                        <img src={Dots} alt="menu" width={30} height={30} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu variant=" shadow">
                        {isEditable ? (
                          <>
                            <Dropdown.Item role={"button"} onClick={onEditData}>
                              <img
                                src={Edit}
                                className="img-fluid"
                                alt="Edit"
                                width="15"
                                height="15"
                              />
                              &nbsp; Edit
                            </Dropdown.Item>
                            <Dropdown.Item onClick={onDeletePress} href="">
                              <img
                                src={Delete}
                                className="img-fluid"
                                alt="Delete"
                                width="15"
                                height="15"
                              />
                              &nbsp; Delete
                            </Dropdown.Item>
                            <Dropdown.Item
                              role={"button"}
                              onClick={onPrivatePress}
                            >
                              <img
                                src={Private}
                                className="img-fluid"
                                alt="Edit"
                                width="15"
                                height="15"
                              />
                              &nbsp; Make {"Private"}
                            </Dropdown.Item>
                            <Dropdown.Item
                              role={"button"}
                              onClick={handleShare}
                            >
                              <img
                                src={Share}
                                className="img-fluid"
                                alt="Edit"
                                width="15"
                                height="15"
                              />
                              &nbsp; Share Wheel
                            </Dropdown.Item>

                            {wheelType !== "clones" && (
                              <Dropdown.Item onClick={onDuplicateWheel} href="">
                                <img
                                  src={Duplicate}
                                  className="img-fluid"
                                  alt="duplicate"
                                  width="15"
                                  height="15"
                                />
                                &nbsp; Make Duplicate
                              </Dropdown.Item>
                            )}
                            <Dropdown.Item
                              onClick={onDownloadButtonClick}
                              href=""
                            >
                              <img
                                src={ASSETS.download}
                                className="img-fluid"
                                alt="Delete"
                                width="15"
                                height="15"
                              />
                              &nbsp; Download as PNG
                            </Dropdown.Item>
                          </>
                        ) : (
                          <Dropdown.Item
                            onClick={() => handleCloneWheel(data?.id)}
                          >
                            <img
                              src={Clone}
                              className="img-fluid"
                              alt="Share"
                              width="15"
                              height="15"
                            />
                            &nbsp; Make clone
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              <div
                ref={ref}
                style={{
                  paddingTop: "12px",
                  //   height: "420px",
                  //   width: "400px",
                  position: "relative",
                }}
              >
                <WheelComponent
                  userData={{
                    id: Math.random() * 10,
                    url: data.wheel_image,
                  }}
                  maxSelectedArcs={0}
                  arcThickness={-10}
                  chartData={chartState}
                  containerDivStyle={{
                    height: "400px",
                    width: "400px",
                  }}
                ></WheelComponent>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
  else return <></>
}
